import { SocialShare } from "@components/C285_SocialShare/C285_SocialShare";
import { NextContentfulImage } from "@components/Image";
import { SiteSettings } from "@customTypes/SiteSettings";
import { useId, useMemo } from "react";
import { Results } from "../CoveoSearchComponent";
import { getTopicIdAndName } from "../coveoUtils";
import { ICON_TYPE, IconLink } from "./Icon";

interface BsrResultsTemplateProps {
  siteSettings?: SiteSettings;
  result: Results;
  handleSelect?: () => void;
}

export const BsrResultsTemplate = (props: BsrResultsTemplateProps) => {
  const { result, siteSettings } = props;
  const dateString = result?.raw?.articledatetext || "";
  const mediaType = result?.raw?.articlemediatype;

  const iconType = useMemo((): ICON_TYPE => {
    if (mediaType?.toLowerCase()?.includes("podcast")) {
      return "podcast";
    }
    if (mediaType?.toLowerCase()?.includes("video")) {
      return "video";
    }
    return "article";
  }, [mediaType]);

  function getSlugByType(resultPageCollection, type) {
    const item = resultPageCollection.items.find((item) => item.type === type);
    return item;
  }

  const linkData =
    siteSettings &&
    getSlugByType(
      siteSettings?.searchResultsPagesCollection,
      "think-articletopics"
    );

  const showImage =
    result?.raw?.articleimageurl &&
    !result?.raw?.articleimageurl.includes("undefined");
  const id = useId();
  const titleId = `bsr-title-${id}`;

  return (
    <article>
      <div>
        {showImage && (
          <div className="relative">
            <div className="wrapperImage">
              <a className="imageLink" href={result.clickUri} onClick={props.handleSelect}>
                <NextContentfulImage
                  src={result.raw.articleimageurl}
                  alt=""
                  role="presentation"
                  width={896}
                  height={504}
                  sizes="(max-width: 768px) 100vw, 20vw"
                />
              </a>
            </div>
            <IconLink
              href={result.clickUri}
              type={iconType}
              className="absolute right-6 -bottom-9"
            />
          </div>
        )}
        <div className="text1">
          <div className="flex flex-col gap-3">
            {!showImage && (
              <IconLink
                href={result.clickUri}
                type={iconType}
                className="self-end"
              />
            )}
            <p className="primary-tag">Think at London Business School </p>
          </div>
          <h2 id={titleId} className="h3">
            <a className="coveo-link" href={result.clickUri} onClick={props.handleSelect}>
              {result?.raw?.articletitle}
            </a>
          </h2>
          <p className="sub-heading medium-light">{dateString}</p>
          <p
            className="CoveoFieldValue copy medium-light"
            data-field="@shortdescription"
          >
            <span>{result.raw.pagedescription}</span>
          </p>
          {result.raw.articleauthorsnames && (
            <p
              className="CoveoFieldValue info-field"
              data-field="@articleauthorsnames"
            >
              By
              <span className="authors">
                {result?.raw?.articleauthorsnames
                  .map((author) => author)
                  .join(", ")}
              </span>
            </p>
          )}
          <div className="card-footer" role="group" aria-labelledby={titleId}>
            {result.raw.taz120xonomytopics?.map((topic, i) => {
              const [id, name] = getTopicIdAndName(topic);
              return (
                <div key={`${name}${i}`} className="component tag cf">
                  <a href={`/${linkData?.url?.slug}?${id}=${name}`}>{name}</a>
                </div>
              );
            })}
            <SocialShare url={result.clickUri} />
          </div>
        </div>
      </div>
    </article>
  );
};

export default BsrResultsTemplate;
